var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.33335L3.33335 2.33337C2.78107 2.33337 2.33335 2.78108 2.33335 3.33337V6.00003H2.37371C2.84684 6.00003 3.29987 6.19133 3.62982 6.53043C3.81725 6.72307 3.95787 6.95625 4.04079 7.21192L4.07435 7.3154C4.21868 7.76041 4.21868 8.23964 4.07435 8.68465L4.04079 8.78813C3.95787 9.0438 3.81725 9.27697 3.62982 9.46962C3.29987 9.80872 2.84684 10 2.37371 10H2.33335V12.6667C2.33335 13.219 2.78107 13.6667 3.33335 13.6667L12.6667 13.6667C13.219 13.6667 13.6667 13.219 13.6667 12.6667V10H13.6263C13.1532 10 12.7002 9.80871 12.3702 9.4696C12.1828 9.27696 12.0422 9.04378 11.9592 8.78811L11.9257 8.68464C11.7814 8.23963 11.7814 7.76039 11.9257 7.31538L11.9592 7.2119C12.0422 6.95623 12.1828 6.72306 12.3702 6.53042C12.7002 6.19131 13.1532 6.00001 13.6263 6.00001H13.6667V3.33335C13.6667 2.78107 13.219 2.33335 12.6667 2.33335Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.16667 A0.33333 0.33333 0 1 0 8 4.5 A0.33333 0.33333 0 1 0 8 5.16667 M8 8.66667 A0.33333 0.33333 0 1 0 8 8 A0.33333 0.33333 0 1 0 8 8.66667 M8 11.86667 A0.33333 0.33333 0 1 0 8 11.2 A0.33333 0.33333 0 1 0 8 11.86667",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/Leave.b0918fe8bc64eb9832d849e07a515308.svg";
export { ForwardRef as ReactComponent };